import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { UserContext } from '../../../context';
import { default as t } from '../../../utils/i18n';
import './choose-report-type.scss';
import { Paper, Step, StepContent, StepLabel, Stepper, Typography, makeStyles } from '@material-ui/core';

import { ReactComponent as ChooseLiveImg } from '../../../assets/svg/stepper_group.svg';

import { ReactComponent as Illust_1 } from '../../../assets/svg/illust_1.svg';
import { ReactComponent as Illust_2 } from '../../../assets/svg/illust_2.svg';
import { ReactComponent as Illust_3 } from '../../../assets/svg/illust_3.svg';
import { ModalWindow, ActionLink, Button } from '../../atoms';


const list_report = [
  {
    "img": <Illust_1 />,
    "title": t('define.report.type.typelist.title1'),
    "discription": t('define.report.type.typelist.discription1'),
    "type": "LIVE"
  },
  {
    "img": <Illust_2 />,
    "title": t('define.report.type.typelist.title2'),
    "discription": t('define.report.type.typelist.discription2'),
    "type": "EOCR"
  },
  {
    "img": <Illust_3 />,
    "title": t('define.report.type.typelist.title3'),
    "discription": t('define.report.type.typelist.discription3'),
    "type": "PCA"
  }
];


const ChooseReportType = ({ activeStep, setActiveStep, stepperData, setStepperData }) => {
  const { user, setUser } = useContext(UserContext);
  const history = useHistory();
  const authenticated = user?.authenticated;

  const [isActive, setIsActive] = useState(false);
  const [value, setValue] = useState(0);
  const [showCancelModal, setShowCancelModal] = useState(false);

  useEffect(() => {
    setStepperData(list_report[0].type);
    setUser(prevUser => ({
      ...user,
      activeStep: 0,
      'draftReportId': '',
      'reportName': '',
      'reportType': ''
    }));
    if (stepperData) {
      setStepperData(stepperData);
      let index = list_report.findIndex(report => report.type === stepperData);
      if (index > -1) {
        setValue(index)
      }
    }
  }, []);

  const handleClick = () => {
    setUser(prevUser => ({
      ...user,
      'reportType': stepperData
    }));
    setActiveStep(activeStep + 1);
  };

  const chooseType = (index) => {
    setValue(index);
    setStepperData(list_report[index].type);
  }

  const handleCancelClick = (e) => {
    e.preventDefault();
    setShowCancelModal(true);
  }

  const handleOnCloseCancelModal = () => {
    setShowCancelModal(false);
  }

  const onContinue = (e) => {
    e.preventDefault();
    setShowCancelModal(false);
    history.push('/reports');
  }

  const onCancelReq = () => {
    setShowCancelModal(false);
  }

  return (
    <div className='choose-report'>
      <div className='exit'>
        <button className='step-cancel'
          onClick={handleCancelClick}>
          {t('report.client.reporting.exit')}
        </button>
      </div>
      <h3>{t('define.report.type.header')}</h3>
      <p>{t('define.report.type.subheader')}</p>
      <div className='choose-report-container'>
        {list_report.map((data, index) => {
          return (

            <button className={`choose-report-c ${index == value ? 'select-c' : ''}`} key={index} id={'type-' + index} onClick={() => chooseType(index)}>
              <div className={'img-report img-' + index}>{data.img}</div>
              <div className='choose-r-container'>
                <h2 className='choose-r-h'>{data.title}</h2>
                <p className='choose-r-p'>{data.discription}</p>
              </div>
            </button>
          )
        })}

      </div>
      <div className='btn-steps' style={{ marginTop: "230px" }}>
        <button className='step-next'
          onClick={handleClick} label="Next">{t('define.report.stepper.button.next')}
        </button>
      </div>
      <div className="report-delete">
        <ModalWindow
          className="fqa-modal--showanswer"
          isOpen={showCancelModal}
          onRequestClose={handleOnCloseCancelModal}
          heading={t('define.stepper.cancel.heading')}
        >
          <p className="fqa-model-showanswer--message message-font">{t('define.stepper.cancel.subHeading')}</p>
          <p>
          </p>
          <div className="fqa-model-pa--actions action-items">
            <ActionLink
              anchor={true}
              value={t('define.stepper.continue')}
              handleClick={onContinue}
            />
            <Button
              className="fqa-model-pa--actions-confirm delete-button"
              label={t('define.stepper.cancel')}
              handleClick={onCancelReq}
            />
          </div>
        </ModalWindow>
      </div>
    </div>
  );
}

export default ChooseReportType;